/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Shop_Home_Story_StatsInputs */

const vi_shop_home_story_stats = /** @type {(inputs: Shop_Home_Story_StatsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Số liệu nổi bật (tối đa ${i?.max})`)
};

/**

* @param {Shop_Home_Story_StatsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_story_stats = /** @type {((inputs: Shop_Home_Story_StatsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Story_StatsInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_story_stats(inputs)
});